import React, { memo } from "react";

const Uom = ({ value, disabled, center, title, offsetText, ...rest }) =>  {

    return (
		<g>
			<text
				transform={`translate(${center.x + offsetText},${center.y + 30})`}
				opacity={disabled ? 0.4 : undefined}
				dominantBaseline="middle"
				textAnchor="middle"
			>
				{value}
			</text>
			<text
				transform={`translate(${center.x + offsetText},${center.y + 50})`}
				dominantBaseline="middle"
				textAnchor="middle"
				opacity={disabled ? 0.4 : undefined}
				fontSize={14}
				fontWeight={'bold'}
			>
				{title}
			</text>
		</g>
	);
  
}

export default memo(Uom);
